
import styles from '../style.module.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";
import ClockIcon from 'assets/SVG/ClockIcon';
import PhoneSvg from "assets/SVG/PhoneSvg";
import "swiper/css";

function BranchesSlider(props) {

    const { addresses, selectedIndex, setSelectedIndex, handleMarkerClick, handleAddressClick } = props;
    const { currentLanguage } = useSelector(({ main }) => main);
    if (!addresses || addresses.length === 0) return null;

    return (
        <div className={styles.branches_slider}>
            <Swiper
                spaceBetween={10}
                slidesPerView="auto"
                speed={300}
                allowTouchMove={true}
            >
                {addresses.map((address, index) => (
                    <SwiperSlide
                        key = { address.id.toString() }
                        onClick = {() => {
                            handleAddressClick(
                                address.location.lat,
                                address.location.lng,
                                index
                            );
                            handleMarkerClick(address)
                        }}
                        style = {{
                            width: "300px",
                            display: 'flex',
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                    >
                        <div
                            style = {{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                gap: "10px",
                            }}
                        >
                            <div
                                style = {{
                                    width: "100%",
                                    aspectRatio: 1.5,
                                    position: "relative",
                                }}
                            >
                                <img
                                    src = { process.env.REACT_APP_STORAGE_URL + address['image_' + currentLanguage] }
                                    alt = { address.name || "brand" }
                                    style = {{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "15px",
                                        border: selectedIndex === index ? "1px solid red" : "none",
                                    }}
                                />
                                <div className={styles.address_working_times}>
                                    <ClockIcon/>
                                    <span>{ address['work_time_' + currentLanguage] }</span>
                                    <div
                                        style = {{
                                            width: '1px',
                                            height: '10px',
                                            backgroundColor: 'gray'
                                        }}
                                    />
                                    <PhoneSvg
                                        width={12}
                                        height={12}
                                    />
                                    <span>
                                        { address['tel_' + currentLanguage] }
                                    </span>
                                </div>
                            </div>
                            <span style = {{ fontWeight: "bold" }}>
                                { address['address_' + currentLanguage] }
                            </span>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default BranchesSlider;